/**
 * API Configuration for GovJobs Portal
 * 
 * .env options:
 *   REACT_APP_API_BASE_URL - Backend base URL (e.g. https://your-backend.com/api)
 *   REACT_APP_JOBS_ENDPOINT - Full jobs URL (optional)
 *   REACT_APP_RESULTS_ENDPOINT - Full results URL (optional)
 *   REACT_APP_ADMIT_CARDS_ENDPOINT - Full admit cards URL (optional)
 *   REACT_APP_ANSWER_KEYS_ENDPOINT - Full answer keys URL (optional)
 */

// Same-origin /api when on production - avoids www vs non-www CORS & "Failed to fetch"
const getApiBase = () => {
  if (typeof window !== 'undefined' && window.location.hostname.includes('sarkariresult.cloud')) {
    return window.location.origin + '/api';
  }
  return process.env.REACT_APP_API_BASE_URL || 'https://www.sarkariresult.cloud/api';
};
const API_BASE_URL = getApiBase();
const TRACK_API_BASE = API_BASE_URL;
const JOBS_ENDPOINT = process.env.REACT_APP_JOBS_ENDPOINT || `${API_BASE_URL}/get-jobs.php`;
const RESULTS_ENDPOINT = process.env.REACT_APP_RESULTS_ENDPOINT || `${API_BASE_URL}/get-results.php`;
const ADMIT_CARDS_ENDPOINT = process.env.REACT_APP_ADMIT_CARDS_ENDPOINT || `${API_BASE_URL}/get-admit-cards.php`;
const ANSWER_KEYS_ENDPOINT = process.env.REACT_APP_ANSWER_KEYS_ENDPOINT || `${API_BASE_URL}/get-answer-keys.php`;
const ADMISSIONS_ENDPOINT = process.env.REACT_APP_ADMISSIONS_ENDPOINT || `${API_BASE_URL}/get-admissions.php`;

export const API_ENDPOINTS = {
  getAll: `${API_BASE_URL}/get-all.php`,
  getJobs: JOBS_ENDPOINT,
  getJobById: (id) => `${API_BASE_URL}/get-job.php?id=${id}`,
  createJob: `${API_BASE_URL}/add-job.php`,
  updateJob: (id) => `${API_BASE_URL}/jobs/${id}`,
  deleteJob: (id) => `${API_BASE_URL}/jobs/${id}`,
  
  getResults: RESULTS_ENDPOINT,
  getResultById: (id) => `${API_BASE_URL}/get-result.php?id=${id}`,
  createResult: `${API_BASE_URL}/add-result.php`,
  
  getAdmitCards: ADMIT_CARDS_ENDPOINT,
  getAdmitCardById: (id) => `${API_BASE_URL}/get-admit-card.php?id=${id}`,
  createAdmitCard: `${API_BASE_URL}/add-admit-card.php`,
  
  getAnswerKeys: ANSWER_KEYS_ENDPOINT,
  getAnswerKeyById: (id) => `${API_BASE_URL}/get-answer-key.php?id=${id}`,
  createAnswerKey: `${API_BASE_URL}/add-answer-key.php`,

  getAdmissions: ADMISSIONS_ENDPOINT,
  getAdmissionById: (id) => `${API_BASE_URL}/get-admission.php?id=${id}`,
  createAdmission: `${API_BASE_URL}/add-admission.php`,

  trackVisit: (path) => `${TRACK_API_BASE}/track-visit.php?path=${encodeURIComponent(path || '/')}`,

  getTableStructure: (table) => `${API_BASE_URL}/get-table-structure.php?table=${encodeURIComponent(table)}`,
  addColumn: `${API_BASE_URL}/add-column.php`,
  removeColumn: `${API_BASE_URL}/remove-column.php`,
  adminInsertJob: `${API_BASE_URL}/admin-insert-job.php`,
  adminInsert: `${API_BASE_URL}/admin-insert.php`,
  adminUpdate: `${API_BASE_URL}/admin-update.php`,
  uploadNotificationPdf: `${API_BASE_URL}/upload-notification-pdf.php`,
  updateTileVisibility: `${API_BASE_URL}/update-tile-visibility.php`,
  updateTilesBatch: `${API_BASE_URL}/update-tiles-batch.php`,
  updateSectionTilesBatch: `${API_BASE_URL}/update-section-tiles-batch.php`,

  listCustomTables: `${API_BASE_URL}/list-custom-tables.php`,
  createCustomTable: `${API_BASE_URL}/create-custom-table.php`,
  getCustomTableRows: (table) => `${API_BASE_URL}/get-custom-table-rows.php?table=${encodeURIComponent(table)}`,
  insertCustomRow: `${API_BASE_URL}/insert-custom-row.php`,
  updateCustomRow: `${API_BASE_URL}/update-custom-row.php`,
  deleteCustomRow: `${API_BASE_URL}/delete-custom-row.php`,
  dropCustomTable: `${API_BASE_URL}/drop-custom-table.php`,
};

export default API_BASE_URL;
